<template>
  <!-- 创建系统选择版本 -->
  <el-dialog
    :title="titleName"
    :visible.sync="createShopShow"
    v-if="createShopShow"
    :before-close="close"
    :modal-append-to-body="false"
    width="600px"
    custom-class="create-shop"
  >
    <el-form :model="form" :rules="rules" :label-width="formLabelWidth" ref="formdata">
      <el-form-item label="店铺名称：" prop="shop_name">
        <el-input
          v-model="form.shop_name"
          autocomplete="off"
          style="width: 350px"
          placeholder="请输入店铺名称(2-30字符)"
          class="bj_color"
        ></el-input>
      </el-form-item>
      <el-form-item label="选择版本：" prop="version_tag">
        <el-select
          v-model="form.version_tag"
          placeholder="请选择店铺版本"
          style="width: 350px"
          class="bj_color"
        >
          <el-option
            :label="item.version_text"
            :value="item.version_tag"
            v-for="item in version"
            :key="item.version_tag"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="submitForm()">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "CreateShop",
  props: {
    dialogCreateShop: {
      type: Boolean,
      default: false,
    },
    product: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      createShopShow: false,
      formLabelWidth: "120px",
      products: {},
      form: {
        id: '',
        shop_name: "",
        version_tag: "",
      },
      rules: {
        shop_name: [
          { required: true, message: "请输入店铺名称", trigger: "blur" },
          { min: 2, max: 30, message: "长度在 2 到 30 个字符", trigger: "blur" },
        ],
        version_tag: [
          { required: true, message: "请选择店铺版本", trigger: "blur" },
        ],
      },
    };
  },
  watch: {
    dialogCreateShop(val) {
      this.createShopShow = val;
    },
    product(val) {
      this.products = val;
    },
  },
  computed: {
    titleName() {
      return "创建" + this.products.product_title;
    },
    version() {
      return this.products.product_version;
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    submitForm() {
        this.$refs['formdata'].validate((valid) => {
          console.log(valid,"validvalid")
          if (valid) {
            this.form.id = this.products.id
            this.$emit('createSystem',this.form)
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
  },
};
</script>

<style lang="scss" scoped>
.create-shop {
  .bj_color ::v-deep.el-input__inner {
    background: #ffffcc !important;
  }
}
</style>